import jQuery from 'jquery';
window.LForms = {
  externalJQuery: window.jQuery,
  jQuery
};
window.jQuery = jQuery; // for autocomplete-lhc initialization
